import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { assetsPath } from "../utils/assetsPath";

const NewDatePicker = ({
  name,
  control,
  rules,
  errors,
  setValue,
  watch,
  minDate,
  maxDate,
  label,
  trigger, // <-- add trigger prop
}) => {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <label className="labelName">{label}</label>
      <div
        style={{
          width: "100%",
          marginBottom: "15px",
          marginTop: "10px",
          position: "relative",
        }}
      >
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                {...field}
                onChange={(date) => {
                  setValue(name, date ? dayjs(date).format("DD/MM/YYYY") : "");
                  if (trigger) trigger(name); // <-- trigger validation
                }}
                format="DD/MM/YYYY"
                value={
                  field.value && field.value !== "Invalid Date"
                    ? dayjs(field.value, "DD/MM/YYYY")
                    : null
                }
                minDate={minDate ? dayjs(minDate) : null}
                maxDate={maxDate ? dayjs(maxDate) : null}
                sx={{
                  width: "100%",
                  fontFamily: "inherit",
                }}
                slotProps={{
                  textField: {
                    variant: "standard",
                    InputProps: {
                      disableUnderline: true,
                      sx: {
                        fontSize: "15px",
                        border: "1px solid #cccccc",
                        backgroundColor: "#e8e8e8",
                        borderRadius: "8px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "10px",
                        paddingRight: "12px",
                        "& .MuiInputBase-input::placeholder": {
                          color: "#808080",
                          opacity: 1,
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          )}
        />
        {watch(name) && watch(name) !== "Invalid Date" && (
          <img
            src={`${assetsPath.tick}`}
            alt="Tick Icon"
            className="tickIcon-datepicker"
          />
        )}
      </div>
      {errors && (
        <span className="errorField margin-bottom-15 margin-top-minus10">
          Required
        </span>
      )}
    </div>
  );
};

export default NewDatePicker;
